"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_NAMES = Object.freeze({
    SET_USER: "API_SET_USER",
    REQUEST_STATUS: "API_REQUEST_STATUS",
});
//# sourceMappingURL=types.js.map